import { ComponentPropsWithoutRef } from 'react';
import { StyledTD } from './styles';

export const TD = (props: ComponentPropsWithoutRef<'td'>) => <StyledTD {...props} />;
